import { Button, Card } from 'antd';
import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import EmpresaContext from '../../context/empresa-context';

function Empresa() {
  const history = useHistory();
  const { empresa } = useContext(EmpresaContext);

  const autorizacionEmpresa = async () => {
    history.push(`/autorizacion-config-empresa/${empresa.id}`);
  };
  const enlaceEmpresa = async () => {
    history.push(`/enlace-config-empresa/${empresa.id}`);
  };
  const canalesEmpresa = async () => {
    history.push(`/canal-config-empresa/${empresa.id}`);
  };
  return (
    <ResponsiveContainer size="large">
      <Card
        title="Administración de la Empresa"
        loading={!empresa}
        style={{ textAlign: 'left' }}
      >
        <>
          <Button type="link" onClick={autorizacionEmpresa}>
            Autorizaciones
          </Button>
          <br />
          {empresa.codigo === 'segutotal' && (
            <>
              <Button type="link" onClick={enlaceEmpresa}>
                Enlaces
              </Button>
              <br />
              <Button type="link" onClick={canalesEmpresa}>
                Canales
              </Button>
            </>
          )}
        </>
      </Card>
    </ResponsiveContainer>
  );
}
export default Empresa;
